/*
 * @providesModule PrizeBackground
 *
 */

import React from 'react';

import LinearGradient from 'react-native-linear-gradient';
import PropTypes from 'prop-types';
import SkillzImage from 'SkillzImage';
import SkillzStyle from 'SkillzStyle';
import Tournament from 'SKZTournament';
import TournamentTemplateSet from 'SKZTournamentTemplateSet';

export default class PrizeBackground extends React.Component {
  static propTypes = {
    categoryType: PropTypes.string,
    fromVSScreen: PropTypes.bool,
    style: PropTypes.any,
    tournament: PropTypes.instanceOf(Tournament),
    tournamentTemplateSet: PropTypes.instanceOf(TournamentTemplateSet),
  };

  static defaultProps = {
    fromVSScreen: false,
  };

  _gradientColorForRow(): Array {
    switch (this.props.categoryType) {
      default:
      case 'LIVE': {
        return SkillzStyle.gradients.prizeViewLiveEventGradient;
      }
      case 'CASH': {
        return this._gradientColorForFriendsMatch();
      }
      case 'Z': {
        return this._gradientColorForFriendsMatch();
      }
      case 'FRIENDS': {
        return this._gradientColorForFriendsMatch();
      }
      case 'BRACKET': {
        return this._gradientColorForBracketMatch();
      }
      case 'SYNC': {
        return this._gradientColorForFriendsMatch();
      }
    }
  }

  _gradientColorForSyncMatch(): Array {
    if (this.props.fromVSScreen) {
      return this._gradientColorForFriendsMatch();
    }
    return SkillzStyle.gradients.bracketPrizeViewLiveEventGradient;
  }

  _gradientColorForFriendsMatch(): Array {
    const tournament = this.props.tournament;
    if (tournament.isCashTournament()) {
      return SkillzStyle.gradients.prizeViewCashGradient;
    } else if (tournament.total_z_prize > 0.0) {
      return SkillzStyle.gradients.prizeViewZGradient;
    } else if (tournament.ticketz_prize > 0.0) {
      return SkillzStyle.gradients.prizeViewTicketzGradient;
    } else {
      return SkillzStyle.gradients.prizeViewLiveEventGradient;
    }
  }

  _gradientColorForBracketMatch(): Array {
    const tournament = this.props.tournament;
    if (tournament.isCashTournament()) {
      return SkillzStyle.gradients.bracketPrizeViewCashGradient;
    } else if (tournament.total_z_prize > 0.0) {
      return SkillzStyle.gradients.bracketPrizeViewZGradient;
    } else if (tournament.ticketz_prize > 0.0) {
      return SkillzStyle.gradients.prizeViewTicketzGradient;
    } else {
      return SkillzStyle.gradients.bracketPrizeViewLiveEventGradient;
    }
  }

  _imageForNameForRow(): string {
    switch (this.props.categoryType) {
      default:
      case 'LIVE': {
        return SkillzStyle.images.prizeViewLiveEventImage;
      }
      case 'CASH': {
        return SkillzStyle.images.prizeViewCashImage;
      }
      case 'Z': {
        return SkillzStyle.images.prizeViewZImage;
      }
      case 'SYNC': {
        return this._imageForSyncTemplates();
      }
      case 'FRIENDS': {
        return this._imageForFriendsTournament();
      }
      case 'BRACKET': {
        return this._imageForBracketMatch();
      }
    }
  }

  _imageForSyncTemplates(): string {
    if (!this.props.tournamentTemplateSet || !this.props.tournamentTemplateSet.friend) {
      return SkillzStyle.images.prizeViewSyncImage;
    }
    if (this.props.tournamentTemplateSet.isAllCashTournaments()) {
      return SkillzStyle.images.prizeViewCashImage;
    } else if (this.props.tournamentTemplateSet.isAllZTournaments()) {
      return SkillzStyle.images.prizeViewZImage;
    } else if (this.props.tournamentTemplateSet.isAllTicketzTournaments()) {
      return SkillzStyle.images.prizeViewTicketzImage;
    } else {
      return SkillzStyle.images.prizeViewSyncImage;
    }
  }

  _imageForFriendsTournament(): string {
    const tournament = this.props.tournament;
    if (tournament.isCashTournament()) {
      return SkillzStyle.images.prizeViewCashImage;
    } else if (tournament.total_z_prize > 0.0) {
      return SkillzStyle.images.prizeViewZImage;
    } else if (tournament.ticketz_prize > 0.0) {
      return SkillzStyle.images.prizeViewTicketzImage;
    } else {
      return SkillzStyle.images.prizeViewLiveEventImage;
    }
  }

  _imageForBracketMatch(): string {
    const tournament = this.props.tournament;
    if (tournament.isCashTournament()) {
      return SkillzStyle.images.bracketPrizeViewCashImage;
    } else if (tournament.total_z_prize > 0.0) {
      return SkillzStyle.images.bracketPrizeViewZImage;
    } else if (tournament.ticketz_prize > 0.0) {
      return SkillzStyle.images.prizeViewTicketzImage;
    } else {
      return SkillzStyle.images.bracketPrizeViewLiveEventImage;
    }
  }

  render(): React.ReactNode {
    const backgroundImage = this._imageForNameForRow();
    if (backgroundImage) {
      return <SkillzImage style={this.props.style} source={backgroundImage} />;
    } else {
      let gradientColors = this._gradientColorForRow() || [];
      gradientColors = gradientColors.map((color: string): string => {
        return SkillzStyle.convertToOpacity(color, 0.95); // eslint-disable-line no-magic-numbers
      });
      return <LinearGradient style={this.props.style} colors={gradientColors} />;
    }
  }
}
